import React, { Component } from 'react';
import './../css/master.css';
import './../css/header.css';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 

var httpURL = '';
class WeaverHeader extends Component {
	constructor(props){
		super(props);
		this.state={
			passwordValidate:false,
			activeP:"",
		}
	}
	componentDidMount(){
		$("#navbar4").hide();
		$("#navbar5").hide();
			$("#Show_Img").hide();
			$("#span2").hide();
		var activePage = $(window.location).attr("href");
		activePage = activePage.split('/').pop();
		this.setState({activeP:activePage});
		if(activePage === 'weaver' ){
			activePage = "Quotes";
		}else if(activePage == 'availability'){
			activePage = "Availability";
		}else if(activePage == 'update'){
			activePage = "Progress/Dispatch";
		}else if(activePage == 'progressUpdate'){
			activePage = "Progress Update";
		}else if(activePage == 'dispatch'){
			activePage = "Dispatch";
		}else if(activePage == 'workDone'){
			activePage = "Work Done";
		}else if(activePage == 'wvrPendingChanges'){
			activePage = "Pending Changes";
		}else{
			activePage = "PO";
		}
		$('#activePageName').text(activePage);
		$('#span2').text(activePage);
		this.animatedLogo();
		window.addEventListener('load', this.animatedLogo);
	};

	animatedLogo=()=>{
		var x = 'left';
		setInterval(()=>{
			if(x == 'left'){
				$('#logoImg').css({'transform':'rotateY(360deg)', 'transition':'4s'});
				x = 'right';
			}else{
				$('#logoImg').css('transform','rotateY(0deg)');
				x = 'left';
			}
		}, 5000);
	}

	openChangePwdDialog(){
		$('.changePwdDiv').show();
		$('.navbar,.main').addClass('addOpacity');
	}

	closeChangePwdDialog(){
		$('.changePwdDiv').hide();
		$('.navbar,.main').removeClass('addOpacity');
	}
	
	passValidate =()=> {
		var currentPassword=$('#currentPassword').val();
		var newPassword=$('#newPassword').val();
		var confirmPassword=$('#confirmPassword').val();
	
		var passPattern = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])[^\\s?].{7,20}$");
	
		if(currentPassword === null || currentPassword === ""){
			toast.warning('Enter old password');
			$('#currentPassword').focus();
			return false;
		}
		if(newPassword === null || newPassword === ''){
			toast.warning('Enter New password');
			$('#newPassword').focus();
			return false;
		}
		
		var res = passPattern.test(newPassword);
		
		if(!res ){
			toast.warning('Please follow the password pattern');
			$('#newPassword').focus();
			return false;
		}
		
		if(newPassword !== confirmPassword){
			toast.warning('Confirm password does not match');
			$('#confirmPassword').focus();
			return false;
		}
		return true;
	}

	changePassword =()=> {
		var queryString = require('querystring');
		var currentPassword=$('#currentPassword').val();
		var newPassword=$('#newPassword').val();
		var emailId=sessionStorage.getItem('weaverEmail');
		if(this.passValidate()){
			axiosInstance.post(httpURL+'/w/l/changepassword',
				queryString.stringify({"weaverEmail" : emailId, "oldPassword": currentPassword, "newPassword": newPassword}), {withCredentials:true}
			).then((response) => { 
				if(response.data.SvcStatus === "Success"){
					toast.success(response.data.SvcMsg);
					this.closeChangePwdDialog();
					window.location.href = window.WVRURL;
				}
				else{
					toast.error(response.data.SvcMsg);
				}
			}).catch((error) => {
				toast.error("Service failed "+error);
			});
		}
	}

	hideMenu=()=>{
		$(".navbar").hide('fast', function(){
			$("#navbar4").show(100).addClass('glyphicon glyphicon-menu-hamburger').css({'color':'orange',marginTop:2});
			$("#navbar5").show(100).addClass('glyphicon glyphicon-off').css({'color':'orange',marginTop:2});
			$("#Show_Img").show();
			$("#span2").show();
			$(".main").css({'height' : '94%'});
			$(".nav-hide").css({display:'block', padding: '2px 5px'});
		});
	}
	
	showMenu=()=>{
		$("#navbar4").hide();
		$("#show_img").hide();
		$("#span2").hide();
		$(".navbar").show(100, function(){
			$(".main").css('height' , '92%');
	$(".nav-hide").css({display:'none'});
	$("#navbar5").hide();
		});
	}
	
	logout(){
		var tokenid = localStorage.getItem('wtokenid')
		axiosInstance.get(httpURL+`/w/l/logout?tokenid=${tokenid}`, {withCredentials:true}
		).then((response) => { 
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg)
				localStorage.removeItem('tokenid')
				setTimeout(
					function () {
						window.location.href = window.WVRURL;
					}.bind(this),
					2000
				  );
			}
			else{
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
				toast.error("Service failed "+error);
		});
	}
  
  render() {
		httpURL = window.httpURL;
    return (
		<div>
			<ToastContainer autoClose={2000} hideProgressBar />
			<nav className="navbar">
			  <div className="container-header" style={{backgroundColor: 'transparent', paddingTop:0,paddingLeft:1}}>
				<div className="navbar-header">
				  <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>                        
				  </button>
				  <div>
				  <button type="button" className="navbar-btn btn" style={{marginLeft:2}} onClick={this.hideMenu}><i style={{textStroke:'none', color:'orange'}} className="glyphicon glyphicon-arrow-left"></i></button>
					<img id="logoImg" src={require("../images/logo.png")} alt="logo.png" style={{width:50, margin:'auto', left:0, bottom:0, top:0, right:0}}  />
				  </div>
				</div>
				<div className="collapse navbar-collapse" id="myNavbar">
				  <ul className="nav navbar-nav" id="mainUL">
					<li><Link to="/wvr/weaver">Quotes</Link></li>
					<li><Link to="/wvr/po">PO</Link></li>
					<li><Link to="/wvr/availability">Availability</Link></li>
					<li><Link to="/wvr/update">Progress/Dispatch</Link></li>
					<li><Link to="/wvr/wvrPendingChanges">Pending Changes</Link></li>
					</ul>
				  <ul className="nav navbar-nav navbar-right">
					<li className="active-icon"><i className="fa fa-snowflake-o" aria-hidden="true"></i></li>
					<li><h4 className="navbar-text" id="activePageName"></h4></li>
					<li><button type="button" id="changePwd" onClick={this.openChangePwdDialog} style={{marginRight:20}} className="navbar-btn btn btn-danger">Change Password</button></li>
					<li><button type="button" id="logout" onClick={this.logout} className="navbar-btn btn btn-danger"><i className="glyphicon glyphicon-off"></i></button></li>
					 </ul>
				</div>
			  </div>
			</nav>
			<div className="nav-hide" style ={{flexDirection:'row',marginLeft:2}}>
			<span className="navbar-btn btn" id="navbar4" onClick={this.showMenu} style={{padding:0,width:26,height:20,paddingLeft:5,paddingRight:5,margin:0,marginBottom:4}}>
				   

			</span>
			<span className="active-menu" id="span2">  {this.state.activeP}</span>
			<span className="navbar-btn btn" id="navbar5" onClick={this.logout} style={{padding:0,width:26,height:20,paddingLeft:5,paddingRight:5,margin:0,marginBottom:4}}></span>
			</div>
			
			<div className="changePwdDiv" style={{opacity:'1 !important'}}>
				<h3 style={{textAlign:'center', color:'rgb(247,150,70)'}}>Change Password</h3>
				<form id="changePwdForm">
					<div className="form-group input-group" style={{marginTop:40, marginBottom:40, width:'100%'}}>
					  <span className="has-float-label">
						  <input type="text" className="form-control" id="currentPassword" placeholder="Current Password" />
						  <label htmlFor="currentPassword">Current Password</label>
					  </span>
					</div>
					<div className="form-group input-group" style={{marginTop:40, marginBottom:40, width:'100%'}}>
						<span className="has-float-label">
							<input type="password" className="form-control" id="newPassword" placeholder="New Password" />
							<label htmlFor="newPassword">New Password</label>
						</span>
					</div>
					<div className="form-group input-group" style={{marginTop:30, marginBottom:30, width:'100%'}}>
					  <span className="has-float-label">
						  <input type="password" className="form-control" id="confirmPassword" placeholder="Confirm Password" />
						  <label htmlFor="confirmPassword">Confirm Password</label>
					  </span>
					</div>
					<div style={{marginTop:50}}>
						<button style={{width:90, height:35, fontSize:18}} type="button" className="btn btn-warning text-center" onClick={this.changePassword}>Change</button>
						<button style={{width:90, height:35, fontSize:18}} type="button" className="btn btn-warning text-center pull-right" id="closeDialog" onClick={this.closeChangePwdDialog}>Close</button>
					</div>
				</form>
			</div>
		</div>
	);
  }
}

export default WeaverHeader;
